module.exports = __webpack_public_path__ + "media/tent.634151b7.mp4";